export default "__VITE_ASSET__DHPqAk84__"